<template>
<ul class="related-many related-blocks">
  <template v-for="(block, ii) in value" :key="block.uuid || block.rand">
    <li class="new">
      <button class="btn btn-primary" v-on:click.prevent="componentPopup=true; insertIndex=ii"><i :class="'fas fa-plus'"></i></button>
      <div class="class-edit-block-type-list" v-if="componentPopup && insertIndex==ii">
        <button v-for="(type, typeid) in types" class="btn btn-primary" v-on:click.prevent="addNew(typeid)" href="">
          <i :class="'fas fa-'+type.icon"></i>{{ type.label }}
        </button>
      </div>
    </li>
    <li class="related-block">
      <button class="btn btn-danger" @click.prevent="removeItem(ii)">
        <i :class="'fas fa-xmark'"></i>
      </button>

        <BlockText v-if="block.type=='paragraph'" :key="'text-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false"></BlockText>
        <BlockText v-if="block.type=='blockquote'" :key="'blockquote-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false" p-class="bquote"></BlockText>
        <BlockText v-if="block.type=='ul'" :key="'ul-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false" p-class="ul"></BlockText>
        <BlockText v-if="block.type=='ol'" :key="'ol-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false" p-class="ol"></BlockText>
        <BlockHeading :key="'heading-edit-block-'+(block.dataid || block.id)" v-if="block.type=='h2' || block.type=='h3' || block.type=='h4'" :heading-type="block.type" v-model="block.content" v-on:new-block="newBlock(bi, $event)"></BlockHeading>
        <BlockHeading :key="'heading-edit-block-'+(block.dataid || block.id)" v-if="block.type=='youtube'" :heading-type="block.type" v-model="block.content" v-on:new-block="newBlock(bi, $event)"></BlockHeading>
        <BlockLink :key="'link-edit-block-'+(block.dataid || block.id)" v-if="block.type=='link'" v-model="block.content" v-on:new-block="newBlock(bi, $event)"></BlockLink>
        <BlockText v-if="block.type=='table'" :key="'table-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false" p-class="table"></BlockText>
        <BlockImg v-if="block.type=='image'" :key="'table-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false"></BlockImg>
        <BlockRelated v-if="block.type=='related'" :key="'related-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false"></BlockRelated>
        <BlockGallery v-if="block.type=='gallery'" :key="'table-edit-block-'+(block.dataid || block.id)" :is-new="block.isNew" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:new-init-done="block.isNew=false"></BlockGallery>


    </li>
  </template>
  <li class="new">
    <button class="btn btn-primary" v-on:click.prevent="componentPopup=true; insertIndex=-1"><i :class="'fas fa-plus'"></i></button>
    <div class="class-edit-block-type-list" v-if="componentPopup && insertIndex==-1">
      <button v-for="(type, typeid) in types" class="btn btn-primary" v-on:click.prevent="addNew(typeid)" href="">
        <i :class="'fas fa-'+type.icon"></i>{{ type.label }}
      </button>
    </div>
  </li>
</ul>
<!--<Popup v-model="componentPopup">
</Popup>-->
</template>

<script>
export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    componentPopup: false,
    insertIndex: null,
    value: [],
    types: {
      paragraph:  { icon: "paragraph", label: "" },
      h2:         { icon: "heading",   label: "2" },
      h3:         { icon: "heading",   label: "3" },
      h4:         { icon: "heading",   label: "4" },
      youtube:    { icon: "video",   label: "" },
      blockquote: { icon: "quote-right", content: "<blockquote></blockquote>" },
      image:      { icon: "image" },
      link:       { icon: "link" },
      gallery:    { icon: "images" },
      ul:         { icon: "list-ul", content: "<ul><li></li></ul>" },
      ol:         { icon: "list-ol", content: "<ol><li></li></ol>" },
      table:      { icon: "table", content: "<table><tr><td>&nbsp;</td></tr></table>" },
//       related:    { icon: "external-link-alt" },
    },
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      },
    },
    modelValue: {
      handler() {
        this.value=this.modelValue || [];
      }, immediate: true,
    },
  },
  computed: {
    type() {
      return this.dbfield.target;
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    addNew(typeid) {
      this.componentPopup=false;

      var newItem={};
      for(var field in this.fieldDesc) {
        if (field!=this.dbfield.name)
          newItem[field]=null;
      }
      if (typeid) {
        newItem.type=typeid;
        newItem.content=this.types[typeid].content || "";
        newItem.rand=Math.random().toString().substring(2);
      }
      if (this.insertIndex==-1)
        this.value.push(newItem);
      else
        this.value.splice(this.insertIndex, 0, newItem);
    },
    selectItem() {
      this.stores.callbacks.pushCallback((...args)=>this.select(...args));
      this.$router.push(this.createLink(this.dbfield.target));
    },
    select(item) {
//       this.stores.callbacks.popCallback();
      this.value.push(item);
      // TODO
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
  },
}
</script>
